import React, { useEffect, useContext, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import NavBar from '../../components/NavBar/NavBar';
import Header from '../../components/Header/Header';
import Filters from '../../components/Filters/Filters';
import Footer from '../../components/Footer/Footer';
import LoadingErrorWrapper from '../../components/Loading/Loading';
import { CouponsContext } from '../../context/CouponsContext';

import useTopCoupons from '../../hooks/useTopCoupons';
import CuponsTop from '../../pages/TopCupons/Cupons';

const categoryInfo = {
    name: 'Top Descontos',
    description:
        'Separamos para você os melhores cupons online, ofertas e descontos do site.',
    slug: 'top-cupons',
    metadataDescription:
        'Os melhores cupons de desconto do momento reunidos em um só lugar. Economize com MeuCupom!',
};

const TopTemplate = () => {
    const { setCoupons } = useContext(CouponsContext);
    const [searchParams] = useSearchParams();

    const page = Number(searchParams.get('page')) || 1;
    const type = searchParams.get('type');
    const category = searchParams.get('category');

    const {
        couponsResponse,
        coupons,
        totalPages,
        loadingCoupons,
        errorCoupons
    } = useTopCoupons({ page, limit: 12, type, category });

    // Só exibe o loading de página inteira na primeira carga, para não
    // desmontar os filtros a cada troca de página/filtro.
    const hasLoadedOnce = useRef(false);
    if (!loadingCoupons) hasLoadedOnce.current = true;

    useEffect(() => {
        setCoupons(couponsResponse);
    }, [couponsResponse, setCoupons]);

    return (
        <LoadingErrorWrapper loading={loadingCoupons && !hasLoadedOnce.current}>
            <div>
                <NavBar hotArea={categoryInfo} />
                <Header hotArea={categoryInfo} />
                <Filters slug={categoryInfo.slug} />

                <CuponsTop
                    coupons={coupons}
                    totalPages={totalPages}
                    loading={loadingCoupons}
                    error={errorCoupons}
                />

                <Footer />
            </div>
        </LoadingErrorWrapper>
    );
};

export default TopTemplate;
